import { lightText, status } from 'src/colors';

export const spaceChangeColors: Record<string, string> = {
  true: status.info,
  false: lightText.secondary,
};
